import React, { useState, useEffect, Fragment } from "react";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useHistory, useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const AssessmentBreakUpWord = ({
  assessment,
  forceUpdate,
  done,
  setRestartKey,
  restartKey,
  setDone,
  setPlay,
  updateAssessmentResult,
  assessmentResults,
  deleteResult,
  clearResult,
  user,
  isAuthenticated,
  setValidationChecklist,
}) => {
  const hist = useHistory();
  const location = useLocation();
  const format = (data) => {
    const Body = data.Body.split(",");
    const Solution = data.Solution.split(",");
    const Scores = data.Scores.split(",");

    let arr = [];
    for (let i = 0; i < Body.length; i++) {
      arr.push({
        word: Body[i],
        solution: Solution[i],
        scores: Scores[i],
      });
    }
    return arr;
  };

  const zeros = (arr) => {
    let r = [];
    for (let i = 0; i < arr.length; i++) {
      r.push(0);
    }
    return r;
  };

  const sum = (id) => {
    let sum = 0;
    const arr = soundsLength;
    for (let i = 0; i < id; i++) {
      sum += parseInt(arr[i]);
    }
    return sum;
  };

  const combine = (id, forward, i) => {
    let temp = [...sounds];
    let templabel = [...soundsLabel];
    let tempLength = [...soundsLength];
    if (forward) {
      console.log(1);
      temp[id] = temp[id] + temp[id + 1];
      temp.splice(id + 1, 1);
      templabel.splice(id + 1, 1);
    } else {
      temp[id] = temp[id - 1] + temp[id];
      temp.splice(id - 1, 1);
      templabel.splice(id - 1, 1);
    }

    tempLength[i] = parseInt(tempLength[i]) - 1 + "";

    setSoundsLength(tempLength);
    setSoundsLabel(templabel);
    setSounds(temp);
  };

  const separate = (arr, ind, i) => {
    let temp = [...sounds];
    let templabel = [...soundsLabel];
    let tempLength = [...soundsLength];
    temp[ind] = "/" + arr[0] + "/";
    for (let i = 1; i < arr.length; i++) {
      temp.splice(ind + i, 0, "/" + arr[i] + "/");
      templabel.splice(ind + i, 0, templabel[ind]);
    }
    tempLength[i] = parseInt(tempLength[i]) + arr.length - 1 + "";
    setSoundsLength(tempLength);
    setSoundsLabel(templabel);
    setSounds(temp);
  };

  const validateEndMark = (results) => {
    if (results.includes("4")) {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: true };
          }
          return item;
        });
      });
    } else {
      setValidationChecklist((prev) => {
        return prev?.map((item) => {
          if (item.desc === "Placed end mark") {
            return { ...item, checked: false };
          }
          return item;
        });
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let data = {
      ...assessmentResults,
      // TotalScore: Math.round(
      //   (scores.reduce((a, b) => {
      //     if (a === "") {
      //       return b;
      //     } else if (b === "") {
      //       return a;
      //     } else {
      //       return a + b;
      //     }
      //   }, 0) /
      //     assessment.Scores.split(",").reduce(
      //       (a, b) => parseInt(a) + parseInt(b),
      //       0
      //     )) *
      //     100
      // ),
      TotalScore: Math.round(
        scores.reduce((a, b) => {
          if (a === "") {
            return b;
          } else if (b === "") {
            return a;
          } else {
            return a + b;
          }
        }, 0),
      ),
      Scores: scores.join(","),
      CategoryID: assessment.CategoryID,
      Comment: comment,
      Year: assessmentResults.year,
      Sounds: sounds,
      SoundsIndex: soundsLabel,
      SoundsLength: soundsLength,
      CreatedDate: new Date().toISOString(),
    };
    // Validate if end mark added
    const endMarkAdded = soundsLabel.includes("4");

    if (!endMarkAdded) {
      setShowWarning(true);
      return;
    }
    setShowWarning(false);
    updateAssessmentResult(data).then(() => {
      hist.push(`/admin/result`);
    });
  };

  const [soundsLabel, setSoundsLabel] = useState(
    assessmentResults.SoundsIndex !== null
      ? assessmentResults.SoundsIndex.split(",")
      : zeros(assessment.Solution.split(",").join(" ").split(" ")),
  );
  const [sounds, setSounds] = useState(
    assessmentResults.Sounds !== null
      ? assessmentResults.Sounds.split(",")
      : assessment.Solution.split(",").join(" ").split(" "),
  );
  const [soundsLength, setSoundsLength] = useState(
    assessmentResults.SoundsLength !== null
      ? assessmentResults.SoundsLength.split(",")
      : assessment.Scores.split(","),
  );

  const [scores, setScores] = useState(() => {
    if (
      assessmentResults.Scores !== null &&
      assessmentResults.Scores !== undefined
    ) {
      return assessmentResults.Scores.split(",").map((score) => {
        const parsed = parseInt(score, 10);
        return isNaN(parsed) ? 0 : parsed;
      });
    }
    // Initialize with zeros based on assessment length
    return new Array(format(assessment).length).fill(0);
  });

  const [comment, SetComment] = useState(
    assessmentResults.Comment === null ? "" : assessmentResults.Comment,
  );

  const [doneCurrent, setDoneCurrent] = useState(
    location.pathname.includes("/assessment/preview/"),
  );

  const [showWarning, setShowWarning] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Calculate scores based on soundsLabel(Label for the sound correct/incorrect/skipped/endmark) and sounds(actual sounds) and sounds length(length of each sound)

  useEffect(() => {
    if (soundsLabel.length && sounds.length && soundsLength.length) {
      // Find endmark position
      const endMarkIndex = soundsLabel.findIndex(
        (val) => val === "4" || val === 4,
      );

      // Create a new scores array to update all at once
      const newScores = [...scores];

      // Go through each word group
      for (let i = 0; i < soundsLength.length; i++) {
        let wordScore = 0;
        const wordLength = parseInt(soundsLength[i]);
        const startIndex = sum(i); // Calculate start index for this word group

        // Calculate score for this word group
        for (let j = 0; j < wordLength; j++) {
          const soundIndex = startIndex + j;

          // Stop scoring after end mark
          if (endMarkIndex !== -1 && soundIndex > endMarkIndex) {
            break;
          }

          // If soundsLength is 1 and empty, score is 0
          if (soundsLength[i] === "1") {
            newScores[i] = 0;
            continue;
          }

          const soundLabel = parseInt(soundsLabel[soundIndex]);

          // Score based on MenuItem logic:
          // - Self Correction (3) = 1 point
          // - Old Correct (1) = 1 point (if you still use it)
          // - Incorrect (2) = 0 points
          // - Skip (5) = 0 points
          // - End Mark (4) = 0 points
          // - No response (0) = 1 point (default correct)

          if (soundLabel === 1 || soundLabel === 3) {
            wordScore++;
          } else if (soundLabel === 0) {
            wordScore++; // Default to correct if no response
          }
        }

        newScores[i] = wordScore;
      }

      // Update scores all at once
      setScores(newScores);
    }
  }, [soundsLabel, sounds, soundsLength]);

  // Validation Task
  useEffect(() => {
    if (soundsLabel?.length) {
      validateEndMark(soundsLabel);
    }
  }, [soundsLabel]);

  return (
    <form className="w-80 mx-auto" onSubmit={(e) => onSubmit(e)}>
      <table className=" table bg-light">
        <thead>
          <tr>
            <th>Teachers Says</th>
            <th>Solution</th>
            {isAuthenticated && <th>Students Says</th>}
            {isAuthenticated && <th>Number Correct</th>}
          </tr>
        </thead>
        <tbody>
          {format(assessment).map((word, i) => {
            return (
              <tr key={i}>
                <td className="align-middle py-4">{word.word}</td>
                <td className="align-middle py-4">{word.solution}</td>
                <td className="align-middle py-4">
                  {sounds
                    .slice(sum(i), sum(i) + parseInt(soundsLength[i]))
                    .map((sound, id) => (
                      <span
                        key={parseInt(i + "" + id)}
                        className="position-relative"
                      >
                        {/* Click Trigger 
                      - 0: No response
                      - 1: Incorrect response
                      - 2: Self Correction
                      - 3: Skipped

                      * No Click Trigger for End Mark
                      Current letters[id]
                      = 0: No response
                      = 1: Incorrect response
                      = 2: Self Correction
                      = 3: End mark
                      = 4: Skipped
                      */}
                        <ContextMenuTrigger
                          id={"same_unique_identifier" + parseInt(i + "" + id)}
                        >
                          <span
                            className="d-inline-flex align-items-center
                            "
                            style={{
                              minWidth: "1.2em",
                            }}
                            onClick={() => {
                              if (isAuthenticated && !doneCurrent) {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  if (parseInt(soundsLabel[ind]) === 0) {
                                    temp[ind] = 2 + "";
                                  }
                                  // Logic to move from Correct to incorrect
                                  // else if (parseInt(soundsLabel[ind]) === 1) {
                                  //   temp[ind] = 2 + "";
                                  // }
                                  else if (parseInt(soundsLabel[ind]) === 2) {
                                    temp[ind] = 3 + "";
                                  } else if (parseInt(soundsLabel[ind]) === 3) {
                                    temp[ind] = 5 + "";
                                  }

                                  // else if (parseInt(soundsLabel[ind]) === 3) {
                                  //   for (let i = 0; i < temp.length; i++) {
                                  //     if (temp[i] === 4) {
                                  //       temp[i] = 0 + "";
                                  //     }
                                  //   }
                                  //   temp[ind] = 4 + "";
                                  // }
                                  else {
                                    temp[ind] = 0 + "";
                                  }
                                  setSoundsLabel(temp);
                                }
                              }
                            }}
                          >
                            {/* id=0 Handle Blank */}
                            {parseInt(soundsLabel[sum(i) + id]) === 0 && (
                              <span className="time-out px-1 d-inline-flex align-items-center justify-content-center">
                                {sound}
                              </span>
                            )}

                            {/* id=1 Handle Old correct */}
                            {parseInt(soundsLabel[sum(i) + id]) === 1 && (
                              <span className="self-correct px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                                {sound}
                              </span>
                            )}

                            {/* id=2 Incorrect */}
                            {parseInt(soundsLabel[sum(i) + id]) === 2 && (
                              <span className="position-relative">
                                <div
                                  style={{
                                    position: "absolute",
                                    display: "inline-block",
                                    bottom: "100%",
                                    left: "0",
                                    top: "-2em",
                                  }}
                                  className=" w-100 text-center"
                                >
                                  <span className="incorrect px-1 d-inline-flex align-items-center justify-content-center">
                                    <span>/</span>
                                  </span>
                                </div>
                                <span className="button-non">{sound}</span>
                              </span>
                            )}

                            {/* id=3 Self-correct */}
                            {parseInt(soundsLabel[sum(i) + id]) === 3 && (
                              <span className="position-relative">
                                <div
                                  style={{
                                    position: "absolute",
                                    display: "inline-block",
                                    bottom: "100%",
                                    left: "0",
                                    top: "-2em",
                                  }}
                                  className=" w-100 text-center"
                                >
                                  <span className="self-correct px-1   d-inline-flex align-items-center justify-content-center">
                                    <span>SC</span>
                                  </span>
                                </div>
                                <span className="button-non">{sound}</span>
                              </span>
                            )}

                            {/* id=5 Skip */}
                            {parseInt(soundsLabel[sum(i) + id]) === 5 && (
                              <span className="position-relative">
                                <div
                                  style={{
                                    position: "absolute",
                                    display: "inline-block",
                                    bottom: "100%",
                                    left: "0",
                                    top: "-2em",
                                  }}
                                  className="w-100 text-center"
                                >
                                  <span className="skip px-1 d-inline-flex align-items-center justify-content-center">
                                    <span>-</span>
                                  </span>
                                </div>
                                <span className="button-non">{sound}</span>
                              </span>
                            )}

                            {/* id=4 End mark */}
                            {parseInt(soundsLabel[sum(i) + id]) === 4 && (
                              <span>
                                <b style={{ color: "#FAA525" }}>]</b>
                                <span className="time-out px-1   d-inline-flex align-items-center justify-content-center">
                                  {sound}
                                </span>
                              </span>
                            )}
                          </span>

                          {/* Click Menu Trigger */}
                        </ContextMenuTrigger>

                        {/* Move the + icon OUTSIDE the ContextMenuTrigger */}
                        {isAuthenticated &&
                          soundsLength[i] > 1 &&
                          id < parseInt(soundsLength[i]) - 1 && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="25"
                              height="25"
                              fill="currentColor"
                              className="bi bi-plus add-item-btn rounded-circle border border-primary txt-primary border-2 ms-1"
                              viewBox="0 0 16 16"
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation(); // Ensure the click doesn't trigger the ContextMenu

                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  if (parseInt(soundsLength[i]) > 1) {
                                    if (id < parseInt(soundsLength[i]) - 1) {
                                      combine(ind, true, i);
                                    } else {
                                      combine(ind, false, i);
                                    }
                                  }
                                }
                              }}
                            >
                              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                            </svg>
                          )}

                        {/* Context Menu */}
                        {isAuthenticated && !doneCurrent && (
                          <ContextMenu
                            id={
                              "same_unique_identifier" + parseInt(i + "" + id)
                            }
                            className="card react-contextmenu p-1"
                          >
                            {/*id=4 End Mark */}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  for (let i = 0; i < temp.length; i++) {
                                    if (parseInt(temp[i]) === 4) {
                                      temp[i] = 0 + "";
                                    }
                                  }
                                  temp[ind] = 4 + "";
                                  setSoundsLabel(temp);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span
                                style={{ color: "#FAA525" }}
                                className="time-out px-1   d-inline-flex align-items-center justify-content-center"
                              >
                                <b> ]</b>
                              </span>
                              <span>
                                <b>End Mark</b>
                              </span>
                            </MenuItem>

                            {/* id=2 Incorrect */}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  temp[ind] = 2 + "";
                                  setSoundsLabel(temp);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="incorrect px-1 d-flex align-items-center justify-content-center">
                                /
                              </span>
                              <span>
                                <b>Incorrect Response (error)</b>
                              </span>
                            </MenuItem>

                            {/* id=3 Self Correction */}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  temp[ind] = 3 + "";
                                  setSoundsLabel(temp);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="self-correct px-1 txt-primary d-inline-flex align-items-center justify-content-center">
                                SC
                              </span>
                              <span>
                                <b>Self Correction (no error)</b>
                              </span>
                            </MenuItem>

                            {/* id=5 Skip */}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  temp[ind] = 5 + ""; // Changed from 1 to 5 to match your skip logic

                                  setSoundsLabel(temp);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="skip px-1 d-inline-flex align-items-center justify-content-center">
                                -
                              </span>
                              <span>
                                <b>Skipped (error)</b>
                              </span>
                            </MenuItem>

                            {/* Hide Combine */}
                            {/* <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  if (parseInt(soundsLength[i]) > 1) {
                                    if (id < parseInt(soundsLength[i]) - 1) {
                                      combine(ind, true, i);
                                    } else {
                                      combine(ind, false, i);
                                    }
                                    // let temp = [...soundsLabel];
                                    // let score = 0;
                                    // for (
                                    //   let j = sum(i);
                                    //   j < sum(i) + parseInt(soundsLength[i]);
                                    //   j++
                                    // ) {
                                    //   if (parseInt(temp[j]===0) ||
                                    //     parseInt(temp[j]) === 1 ||
                                    //     parseInt(temp[j]) === 3
                                    //   ) {
                                    //     score++;
                                    //   }
                                    // }
                                    // let arr = [...scores];
                                    // arr[i] = score;
                                    // setScores(arr);
                                  }
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="time-out px-1   d-inline-flex align-items-center justify-content-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="#18a587"
                                  class="bi bi-plus-lg"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
                                  />
                                </svg>
                              </span>
                              <span>
                                <b>Combine</b>
                              </span>
                            </MenuItem> */}

                            {/* Separate */}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  const arr = sounds[ind]
                                    .substring(1, sounds[ind].length - 1)
                                    .split("//");
                                  if (arr.length > 1) {
                                    separate(arr, ind, i);
                                    // let temp = [...soundsLabel];
                                    // let score = 0;

                                    // for (
                                    //   let j = sum(i);
                                    //   j < sum(i) + parseInt(soundsLength[i]);
                                    //   j++
                                    // ) {
                                    //   if (
                                    //     parseInt(temp[j]) === 1 ||
                                    //     parseInt(temp[j]) === 3
                                    //   ) {
                                    //     score++;
                                    //   }
                                    // }
                                    // let r = scores;
                                    // r[i] = score;
                                    // setScores(r);
                                  }
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="time-out px-1   d-inline-flex align-items-center justify-content-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="red"
                                  class="bi bi-dash-lg"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
                                  />
                                </svg>
                              </span>
                              <span>
                                <b>Separate</b>
                              </span>
                            </MenuItem>

                            {/* Correct */}
                            {/* \<MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  temp[ind] = 1 + "";
                                  console.log(temp[ind]);
                                  setSoundsLabel(temp);
                                  let score = 0;
                                  for (
                                    let j = sum(i);
                                    j < sum(i) + parseInt(soundsLength[i]);
                                    j++
                                  ) {
                                    if (
                                      parseInt(temp[j]) === 1 ||
                                      parseInt(temp[j]) === 3
                                    ) {
                                      score++;
                                    }
                                  }

                                  let arr = scores;
                                  arr[i] = score;
                                  setScores(arr);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="self-correct px-1   d-inline-flex align-items-center justify-content-center"></span>
                              <span>
                                <b>Correct</b>
                              </span>
                            </MenuItem> */}

                            {/* Cancel*/}
                            <MenuItem
                              onClick={() => {
                                const ind = sum(i) + id;
                                const timeout = soundsLabel.indexOf("4");
                                if (ind <= timeout || timeout === -1) {
                                  let temp = [...soundsLabel];
                                  temp[ind] = 0 + "";
                                  setSoundsLabel(temp);
                                  let score = 0;
                                  for (
                                    let j = sum(i);
                                    j < sum(i) + parseInt(soundsLength[i]);
                                    j++
                                  ) {
                                    if (
                                      parseInt(temp[j]) === 1 ||
                                      parseInt(temp[j]) === 3
                                    ) {
                                      score++;
                                    }
                                  }

                                  let arr = scores;
                                  arr[i] = score;
                                  setScores(arr);
                                }
                              }}
                              className="p-2 btn react-contextmenu-item d-flex align-items-center justify-content-start"
                            >
                              <span className="time-out px-1   d-inline-flex align-items-center justify-content-center"></span>
                              <span>
                                <b>Cancel</b>
                              </span>
                            </MenuItem>
                          </ContextMenu>
                        )}
                      </span>
                    ))}
                </td>

                {/*  Number Correct Area */}
                {isAuthenticated && (
                  <td className="align-middle py-4">
                    <input
                      type="number"
                      disabled
                      required
                      readOnly={true}
                      min={0}
                      max={word.scores}
                      onChange={(e) => {
                        let arr = [...scores];
                        arr[i] = parseInt(e.target.value);
                        setScores(arr);
                      }}
                      value={
                        scores[i] === undefined ||
                        scores[i] === null ||
                        scores[i] === ""
                          ? 0
                          : scores[i]
                      }
                      className="form-control form-silly mr-2 d-inline px-0 text-center "
                    />
                    &nbsp;&nbsp;/&nbsp;{word.scores}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {isAuthenticated && (
        <Fragment>
          <div class="form-floating my-2">
            <textarea
              onChange={(e) => SetComment(e.target.value)}
              class="form-control"
              placeholder="Leave a comment here"
              value={comment}
              readOnly={location.pathname.includes("/assessment/preview/")}
              id="floatingTextarea2"
              style={{ height: "100px" }}
            ></textarea>
            <label for="floatingTextarea2">Comments</label>
          </div>
          <div
            className={`d-flex align-items-center justify-content-${
              !doneCurrent ? "end" : "between"
            } my-3`}
          >
            {doneCurrent && (
              <div className="">
                # Correct{" "}
                {Math.round(
                  scores.reduce((a, b) => {
                    if (a === "") {
                      return b;
                    } else if (b === "") {
                      return a;
                    } else {
                      return a + b;
                    }
                  }, 0),
                )}{" "}
              </div>
            )}
            {!location.pathname.includes("/assessment/preview/") && (
              <div className="d-flex align-items-center justify-content-end mb-2  p-2">
                {doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      setDoneCurrent(false);
                      setDone(false);
                    }}
                  >
                    Edit
                  </button>
                )}

                {!doneCurrent && (
                  <button
                    type="reset"
                    className="button-primary btn-block btn px-5 mx-2"
                    onClick={() => {
                      setScores([]);
                      forceUpdate();
                      setDoneCurrent(false);
                      setDone(false);
                      setSounds(
                        assessment.Solution.split(",").join(" ").split(" "),
                      );
                      setSoundsLabel(
                        zeros(
                          assessment.Solution.split(",").join(" ").split(" "),
                        ),
                      );
                      setSoundsLength(assessment.Scores.split(","));
                    }}
                  >
                    Clear
                  </button>
                )}

                {!doneCurrent ? (
                  <div
                    className="button-primary btn-block btn px-5"
                    onClick={() => {
                      setRestartKey(restartKey + 1);
                      setPlay(false);
                      setDone(true);
                      setDoneCurrent(true);
                      forceUpdate();
                    }}
                  >
                    Save
                  </div>
                ) : (
                  <button
                    className="button-primary btn-block btn px-5"
                    type="submit"
                  >
                    Submit
                  </button>
                )}

                {/* Delete Modal */}
                <Modal
                  show={showDeleteModal}
                  onHide={() => setShowDeleteModal(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Delete Assigned Assessment</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to delete assigned assessment?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowDeleteModal(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => {
                        deleteResult(assessmentResults.ResultID, user.SchoolID);
                        hist.push("/admin/result");
                        clearResult();
                        setShowDeleteModal(false);
                      }}
                    >
                      Confirm
                    </Button>
                  </Modal.Footer>
                </Modal>

                {/* Delete Button */}
                <Button
                  variant="danger"
                  className="d-flex align-items-center px-4 mx-2"
                  onClick={() => setShowDeleteModal(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-trash-fill me-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                  </svg>
                  Delete
                </Button>

                {/* Warning Modal */}
                {/* ✅ Replace the Bootstrap modal with React Bootstrap Modal */}
                <Modal
                  show={showWarning}
                  onHide={() => setShowWarning(false)}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Submission Failed!</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Missing end mark! Please add an end mark (]) before
                    submitting.
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowWarning(false)}
                    >
                      OK, I'll add the end mark
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            )}
          </div>
        </Fragment>
      )}
    </form>
  );
};

export default AssessmentBreakUpWord;
